// extracted by mini-css-extract-plugin
export default {"passwordIcon":"Input_passwordIcon__6YOAm","btnIcon":"Input_btnIcon__CGwHf"};